import axios from 'axios';

import routes from 'app/routes';

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.policy_plans.index)
      .then((resp) => {
        dispatch({ type: 'LOAD', plans: resp.data.data });
      });
  },

  loadEnterprise: (dispatch, enterpriseId) => {
    axios
      .get(routes.api.enterprises.show(enterpriseId))
      .then((resp) => {
        dispatch({ type: 'LOAD_ENTERPRISE', enterprise: resp.data.data });
      });
  },

  isPossibleCreatePlan: ({ policyTemplateId, successCallback }) => {
    axios
      .post(routes.api.policy_plans.possible_start, {
        policy_template_id: policyTemplateId,
      })
      .then((resp) => {
        successCallback(resp.data.data);
      });
  },
  createPlan: (
    dispatch,
    currency,
    enterpriseId,
    values,
    successCallback,
  ) => {
    axios
      .post(routes.api.policy_plans.create, {
        enterprise_id: enterpriseId,
        currency,
        policy_plan: values,
      })
      .then((resp) => {
        successCallback(resp.data.data);
      });
  },

  updatePlan: (
    enterpriseId,
    planId,
    values,
    successCallback,
  ) => {
    axios
      .put(routes.api.policy_plans.update(planId), {
        enterprise_id: enterpriseId,
        policy_plan: values,
      })
      .then((resp) => {
        successCallback(resp.data.data);
      });
  },

  deletePlan: (dispatch, enterpriseId, planId) => {
    axios
      .delete(routes.api.policy_plans.destroy(planId), {
        params: { enterprise_id: enterpriseId },
      })
      .then((_resp) => {
        dispatch({ type: 'DELETE', planId });
      });
  },

  activatePlan: (enterpriseId, planId, callback) => {
    axios
      .post(
        routes.api.policy_plans.activate(planId),
        { enterprise_id: enterpriseId },
      )
      .then((resp) => {
        callback(resp.data.data);
      });
  },

  loadPdf: (values, callback) => {
    axios({
      method: 'post',
      url: routes.api.policy_plans.downloadPdf,
      responseType: 'blob',
      data: {
        data: values,
      },
    })
      .then((resp) => {
        callback(resp.data);
      });
  },

  setCurrency: (dispatch, currency) => {
    dispatch({ type: 'CURRENCY', currency });
  },
};
